import { format } from 'date-fns';

export function formatArticleDate(d: Date): string {
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) {
    throw new TypeError('formatArticleDate expects a valid Date');
  }
  return format(d, 'd MMMM yyyy');
}
